export const BASE_URL = 'api'
export const JWT_LS: string = 'jwt'
export const DATE_FORMAT = 'YYYY-MM-DD'

export const TELEGRAM_BASE_URL = 'https://t.me/'
export const sortEmployeeKeys: string[] = [
  'firstName',
  'lastName',
  'middleName',
  'sex',
  'birthDay',
  'email',
  'phone',
  'telegram',
  'comment',
  'config',
  'isActive'
]

export const sortProjectKeys: string[] = ['title', 'code', 'manager', 'from', 'to', 'comment']

export const SEX = {
  male: 'мужской',
  female: 'женский'
}
